import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { injectIntl } from 'react-intl';
import DateTimeField from 'components/DateTimeField';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';

class DraftSearch extends Component {
  render() {
    let { handleSubmit, onSearch, fetching, intl } = this.props;
    const t = (id) => intl.formatMessage({ id });
    return (
      <form onSubmit={handleSubmit(onSearch)}>
        <Row>
          <Col md={1}>
            <label>{t('draftSearch.createdBtw')}</label>
            <Field
              name="date_from"
              component={DateTimeField}
            />
          </Col>
          <Col md={1}>
            <label>&nbsp;</label>
            <Field
              name="date_to"
              component={DateTimeField}
            />
          </Col>
          <Col md={1}>
            <label>{t('draftSearch.draftNum')}</label>
            <div>
              <Field className="form-control" name="draft_number" component="input" type="text" placeholder="51" />
            </div>
          </Col>
          <Col md={1}>
            <label>{t('draftSearch.shopifyId')}</label>
            <div>
              <Field className="form-control" name="shopify_draft_order_name" component="input" type="text" placeholder="#D122" />
            </div>
          </Col>
          <Col md={2}>
            <label>{t('draftSearch.customer')}</label>
            <div>
              <Field className="form-control" name="customer" component="input" type="text" placeholder="John Doe" />
            </div>
          </Col>
          <Col md={1}>
            <label>{t('draftSearch.status')}</label>
            <Field className="form-control" name="status" component="select">
              <option value="">{t('draftSearch.any')}</option>
              <option value="draft">{t('draftSearch.draft')}</option>
              <option value="sent">{t('draftSearch.sent')}</option>
              <option value="accepted">{t('draftSearch.accepted')}</option>
              <option value="expired">{t('draftSearch.expired')}</option>
              <option value="converted">{t('draftSearch.converted')}</option>
              <option value="cancelled">{t('draftSearch.cancelled')}</option>
            </Field>
          </Col>
          <Col md={1}>
            <label>{t('draftSearch.type')}</label>
            <Field className="form-control" name="document_type" component="select">
              <option value="">{t('draftSearch.any')}</option>
              <option value="quote">{t('draftSearch.quote')}</option>
              <option value="proforma">{t('draftSearch.proforma')}</option>
              <option value="draft_order">{t('draftSearch.draftOrder')}</option>
              <option value="manual_invoice">{t('draftSearch.manualInvoice')}</option>
            </Field>
          </Col>
          <Col md={1}>
            <label>{t('draftSearch.delivery')}</label>
            <Field className="form-control" name="delivered" component="select">
              <option value="">{t('draftSearch.any')}</option>
              <option value="true">{t('draftSearch.delivered')}</option>
              <option value="false">{t('draftSearch.notDelivered')}</option>
              <option value="pending">{t('draftSearch.pending')}</option>
            </Field>
          </Col>
          <Col md={1}>
            <label>&nbsp;</label>
            <button disabled={fetching} type="submit" className="form-control" style={{ cursor: 'pointer', textAlign: 'center', whiteSpace: 'nowrap' }}>
              <i className={fetching ? "fa fa-spin fa-spinner" : "fa fa-search"}></i>&nbsp;{fetching ? t('draftList.loading') : t('draftSearch.search')}
            </button>
          </Col>
        </Row>
      </form>
    );
  }
}

let DraftSearchForm = reduxForm({
  form: 'DraftSearchForm',
  destroyOnUnmount: true
})(injectIntl(DraftSearch));

const selector = formValueSelector('DraftSearchForm');

DraftSearchForm = connect(state => {
  return {
    filter: { ...state.form.DraftSearchForm }
  };
})(DraftSearchForm);

export default DraftSearchForm;



// WEBPACK FOOTER //
// app/components/drafts/DraftSearchForm.jsx